<template>
  <b-form-group
    :disabled="!giveFeedback"
    class="form__criteria-selection"
    :class="{
      'form__criteria-selection--additional':
        criterion.additional_criteria && criterion.additional_criteria.length
    }"
  >
    <div
      v-if="showAllCriteria || passSelected"
      class="container__criteria-pass"
      :class="{ 'container__criteria-pass--selected': passSelected }"
    >
      <label
        v-b-tooltip.hover.bottom="{
          title: criterion.pass_criterion,
          customClass: 'tooltip-criterion text__criteria-description',
          disabled: !giveFeedback
        }"
        class="custom-radio-label"
      >
        <input
          type="radio"
          :name="`part-${formatedPart}-criterion-pass`"
          :value="{ pass: true, additional_criterion: null }"
          :checked="passSelected"
          :disabled="!giveFeedback"
          @change="
            onRadioInputChange($event, { pass: true, additional_criterion: null }, { criterion })
          "
        />
        <div class="text__criteria-title">
          {{ criterion.pass_title }}
        </div>
      </label>
    </div>

    <template v-if="criterion.additional_criteria && criterion.additional_criteria.length">
      <template v-for="(additional_criterion, index) in criterion.additional_criteria">
        <div
          v-if="showAllCriteria || additionalSelected(additional_criterion.id)"
          :key="additional_criterion.id"
          class="container__criteria-almost"
          :class="{
            'container__criteria-almost--selected': additionalSelected(additional_criterion.id)
          }"
        >
          <label
            v-b-tooltip.hover.bottom="{
              title: additional_criterion.description,
              customClass: 'tooltip-criterion text__criteria-description',
              disabled: !giveFeedback
            }"
            class="custom-radio-label"
          >
            <input
              type="radio"
              :name="`part-${formatedPart}-${order}-additional-criterion__${index}`"
              :value="{ pass: false, additional_criterion: additional_criterion.id }"
              :checked="additionalSelected(additional_criterion.id)"
              :disabled="!giveFeedback"
              @change="
                onRadioInputChange(
                  $event,
                  { pass: false, additional_criterion: additional_criterion.id },
                  { additional_criterion }
                )
              "
            />
            <div class="text__criteria-title">
              {{ additional_criterion.title }}
            </div>
          </label>
        </div>
      </template>
    </template>

    <div
      v-if="showAllCriteria || notyetSelected"
      class="container__criteria-not-yet"
      :class="{
        'container__criteria-not-yet--selected': notyetSelected
      }"
    >
      <label
        v-b-tooltip.hover.bottom="{
          title: criterion.not_yet_criterion,
          customClass: 'tooltip-criterion text__criteria-description',
          disabled: !giveFeedback
        }"
        class="custom-radio-label"
      >
        <input
          type="radio"
          :name="`part-${formatedPart}-criterion-not-yet`"
          :value="{ pass: false, additional_criterion: null }"
          :checked="notyetSelected"
          :disabled="!giveFeedback"
          @change="
            onRadioInputChange($event, { pass: false, additional_criterion: null }, { criterion })
          "
        />
        <div class="text__criteria-title">
          {{ criterion.not_yet_title }}
        </div>
      </label>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: 'CriteriaRadioGroup',

  props: {
    criterion: {
      type: Object,
      required: true
    },

    value: {
      type: Object,
      default: null
    },

    giveFeedback: {
      type: Boolean,
      default: false
    },

    formatedPart: {
      type: String,
      required: true
    },

    order: {
      type: Number,
      required: true
    },

    showAllCriteria: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    passSelected() {
      return this.value?.pass === true;
    },

    notyetSelected() {
      return this.value?.pass === false && !this.value?.additional_criterion;
    }
  },

  methods: {
    onRadioInputChange(event, valueObj, payload) {
      // Emit input for v-model
      this.$emit('input', valueObj);

      // Emit radio-change for parent component handler
      this.$emit('radio-change', event, payload);
    },

    additionalSelected(criterionId) {
      return (
        this.value?.pass === false &&
        String(this.value?.additional_criterion) === String(criterionId)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.form__criteria-selection {
  display: flex;

  ::v-deep div {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0;
    gap: 16px;
  }
}

.container__criteria-pass,
.container__criteria-not-yet,
.container__criteria-almost {
  border-radius: 10.4px;
  border: 1px solid #dfe2e6;
  margin-bottom: 12px;

  .custom-radio-label {
    width: 100%;
    text-align: center;
    cursor: pointer;
    margin: 0;
    padding: 12px;
    font-weight: 700;

    input[type='radio'] {
      cursor: pointer;
      accent-color: #3c44b1;
      padding: 10px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: 1px solid #dfe2e6;
      border-radius: 50%;
      position: relative;

      &:checked {
        background-color: #3c44b1;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: #ffffff;
        }
      }

      &:disabled {
        opacity: 1;
        background-color: #f5f5f5;

        &:checked {
          opacity: 0.5;
          background-color: #3c44b1;

          &::after {
            background-color: #ffffff;
          }
        }
      }
    }
  }

  .text__criteria-title {
    margin-top: 8px;
  }
}

.container__criteria-pass--selected {
  background: #cff3f8;
  border-color: #bceff5;

  .text__criteria-title {
    color: #0c6b7e;
  }
}

.container__criteria-not-yet--selected {
  background: #fed6da;
  border-color: #fdc6cb;

  .text__criteria-title {
    color: #841e30;
  }
}

.container__criteria-almost--selected {
  background: #fde4d5;
  border-color: #fcd9c4;

  .text__criteria-title {
    color: #824224;
  }
}

@media screen and (min-width: 768px) {
  .form__criteria-selection ::v-deep div {
    flex-direction: row;
  }
}
</style>

<style lang="scss">
.tooltip-criterion.tooltip.b-tooltip {
  opacity: 1;
}

.tooltip-criterion {
  .arrow::before {
    border-bottom-color: #3b3e66;
  }

  .tooltip-inner {
    background-color: #3b3e66;
    box-shadow: none;
    max-width: 472px;
    white-space: pre-line;
    word-break: break-word;
    text-align: left;
  }
}
</style>
